<template>
  <div class="ts-overflow-scroll ts-max-h-screen">
    <form action="">
      <fieldset>
        <legend>{{ $t('thesis.committeeList') }}</legend>
        <ts-table :columns="columns" :records="committees">
          <template v-slot="{ record, index }">
            <td style="vertical-align: middle" class="ts-text-center">
              {{ index + 1 }}
            </td>
            <td style="vertical-align: middle">
              <b class="ts-text-blue-600">{{
                record.committee_name ? record.committee_name : null
              }}</b>
            </td>
            <td style="vertical-align: middle" class="ts-text-center">
              {{ record.remark ? record.remark : null }}
            </td>
            <td style="vertical-align: middle" class="ts-text-center">
              {{ record.score ? record.score : null }}
            </td>
            <td style="vertical-align: middle" class="ts-text-center">
              {{ record.grade ? record.grade : null }}
            </td>
            <td style="vertical-align: middle" class="ts-text-center">
              {{ record.score_remark ? record.score_remark : null }}
            </td>
            <td style="vertical-align: middle" class="ts-text-center">
              {{ record.status ? record.status : null }}
            </td>
          </template>
        </ts-table>
      </fieldset>
    </form>
  </div>
</template>
<script>
export default {
  name: 'committeList',
  props: ['committees'],
  computed: {
    columns () {
      return [
        {
          name: this.$t('thesis.no'),
          style: 'text-align:center'
        },
        {
          name: this.$t('thesis.employeeName')
        },
        {
          name: this.$t('thesis.description'),
          style: 'text-align:center'
        },
        {
          name: this.$t('thesis.score'),
          style: 'text-align:center'
        },
        {
          name: this.$t('thesis.grade'),
          style: 'text-align:center'
        },
        {
          name: this.$t('thesis.scoreRemark'),
          style: 'text-align:center'
        },
        {
          name: this.$t('thesis.status'),
          style: 'text-align:center'
        }
      ]
    }
  }
}
</script>
<style lang="css" scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table thead tr th {
  text-transform: uppercase;
  padding: 4px 7px;
  background: rgb(218, 218, 218);
}
table tbody tr td {
  padding: 4px 7px;
}
</style>
